/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Features_Upload_DriveInputs */

const en_features_upload_drive = /** @type {(inputs: Features_Upload_DriveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drive`)
};

const es_features_upload_drive = /** @type {(inputs: Features_Upload_DriveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drive`)
};

/**
* | output |
* | --- |
* | "Drive" |
*
* @param {Features_Upload_DriveInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const features_upload_drive = /** @type {((inputs?: Features_Upload_DriveInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Features_Upload_DriveInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_features_upload_drive(inputs)
	return en_features_upload_drive(inputs)
});